import React from 'react';
import { Container, Row, Col, Tabs, Tab, Button, Form } from 'react-bootstrap';
import BatchSelector from './BatchSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faPlay } from '@fortawesome/free-solid-svg-icons';
import BootstrapTable from 'react-bootstrap-table-next';
import $ from 'jquery';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import AceEditor from 'react-ace';
import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/worker-javascript';
import HTMLViewer from './HTMLViewer';
import HARViewer from './HARViewer';
import ScreenshotViewer from './ScreenshotViewer';
import ScriptViewer from './ScriptViewer';
ace.config.set('workerPath', '/static/js/src-noconflict');

const logColumns = [{
    dataField: 'type',
    text: 'Type',
    headerStyle: { width: '60px' }
}, {
    dataField: 'output_snippet',
    text: 'Output Snippet (Click a row for more details about the log)'
}, {
    dataField: 'created_at',
    text: 'Local Time',
    headerStyle: { width: '240px' }
}];

class LogViewer extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            hideRetry: true,
            logPage: 1,
            logSizePerPage: 10,
            logTotalSize: 10,
            logStartKeyIndex: 0,
            logDirection: 'first',
            logScreenshotOutput: null,
            logHarOutput: null,
            logHtmlOutput: null,
            logScreenshotIdx: -1,
            logHarIdx: -1,
            logHtmlIdx: -1,
            logSelectedTabs: {}
        };
        this.getLogs = this.getLogs.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.getLogDetails = this.getLogDetails.bind(this);
        this.refreshLogsHandler = this.refreshLogsHandler.bind(this);
        this.toggleHideRetry = this.toggleHideRetry.bind(this);
        this.getPrettyJson = this.getPrettyJson.bind(this);
        this.shouldWrapText = this.shouldWrapText.bind(this);
        this.handleLogTabSelect = this.handleLogTabSelect.bind(this);
        this.getScreenshot = this.getScreenshot.bind(this);
        this.getHtmlOutput = this.getHtmlOutput.bind(this);
        this.getHarOutput = this.getHarOutput.bind(this);
        this.renderPageButton = this.renderPageButton.bind(this);
        this.renderSinglePageButton = this.renderSinglePageButton.bind(this);
        this.batchChanged = this.batchChanged.bind(this);
    }
    batchChanged() {
        this.refreshLogsHandler();
    }
    handleLogTabSelect(logId, tabId) {
        const newState = { ...this.state.logSelectedTabs };
        newState[logId] = tabId;
        this.setState({ logSelectedTabs: newState });
    }
    shouldWrapText(text) {
        return true;
    }
    getScreenshot(logId) {
        this.props.getScreenshot(logId)
    }
    getHtmlOutput(logId) {
        this.props.getHtmlOutput(logId)
    }
    getHarOutput(logId) {
        this.props.getHarOutput(logId)
    }
    getPrettyJson(jsonData) {
        try {
            const data = JSON.parse(jsonData);
            if (data.script) {
                data.script = "[See Script Viewer in Assets Section]";
            }
            return JSON.stringify(data, null, 4);
        } catch (err) {
            return jsonData;
        }
    }

    getLogs(startKeyIndex = null,direction = null) {
        const extractionId = this.props.currentExtraction.id;
        const batchId = this.props.batchId;
        direction = direction ? direction : (this.state.logDirection ? this.state.logDirection: 'first');
        startKeyIndex = startKeyIndex ? startKeyIndex : (this.state.logStartKeyIndex ? this.state.logStartKeyIndex: 0);
    
        if (!extractionId || !batchId) return;
    
        const logRequest = {
            page_size: this.state.logSizePerPage,
            direction: direction,
            start_key: '',
            previous_start_keys: [],
            only_critical: this.state.hideRetry,
        };

        if (this.state.previous_start_keys && this.state.previous_start_keys.length > 0) {
            logRequest.previous_start_keys = this.state.previous_start_keys;
    
            if (direction === 'backward' && startKeyIndex > 0) {
                logRequest.start_key = this.state.previous_start_keys[startKeyIndex];
                logRequest.previous_start_keys = this.state.previous_start_keys.slice(0, startKeyIndex + 2);
            }
            //  else if (direction === 'backward' && this.state.previous_start_keys.length > 1) {
            //     payload.start_key = this.state.previous_start_keys[this.state.previous_start_keys.length - 2];
            // }
        }
    
        if (direction === 'forward') {
            logRequest.start_key = this.state.lastEvaluatedKey;
        }

        this.props.logService.loadLogs(extractionId, batchId, logRequest).then(res => {
            this.setState({
                startKeyIndex: startKeyIndex,
                logTotalSize: res.log_count,
                lastEvaluatedKey: res.last_evaluated_key,
                previousStartKeys: res.previous_start_keys,
            }, () => {
                this.props.stateManagementService.updateLogs(res.formatted_logs);
            });
        }).catch(error => {
            console.error(error);
        });
    }
    
    retryCriticalJobs() {
        this.props.logService.retryCriticalJobs(this.props.currentExtraction.id, this.props.batchId).then(res => {
            this.refreshLogsHandler()
        }).catch(error => {
            console.error(error);
        });
    }
    handleTableChange(type, details) {
        var direction = "na"
        if (details.page > this.state.logPage) {
            direction = 'forward'
        } else if (details.page < this.state.logPage) {
            direction = 'backward'
        } else if (details.page == 0) {
            direction = 'first'
        }
        const startKeyIndex = details.page - 1
        if (details.page > 0) {
            this.setState({
                logPage: details.page,
                logSizePerPage: details.sizePerPage,
                logDirection: direction,
                logStartKeyIndex: startKeyIndex
            });
            this.getLogs(startKeyIndex, direction = direction);
        }
    }
    refreshLogsHandler() {
        this.getLogs();
    }
    retryCriticalJobsHandler(extractionId = null, batchId = null) {
        var sId = extractionId != null ? extractionId : this.props.currentExtraction.id
        var bId = batchId != null ? batchId : this.props.batchId
        this.retryCriticalJobs(sId, bId);
    }
    getLogDetails(logID) {
        for (var i = 0; i < this.props.logs.length; i++) {
            if (this.props.logs[i].id == logID) {
                return this.props.logs[i];
            }
        }
    }
    toggleHideRetry(checked) {
        this.setState({
            hideRetry: checked
        }, () => {
            if (this.props.currentExtraction.id  != null) {
                this.getLogs();
            }
        });
    }

    renderPageButton(pageProps) {
        const {
            page,
            active,
            disabled,
            title,
            onPageChange
        } = pageProps;
        
        // Get current page from component state
        const currentPage = this.state.logPage;
        
        // For numbered pages, only show if they're less than current page
        if (!isNaN(page)) {
            if (parseInt(page) >= currentPage) {
                return null;
            }
            return this.renderSinglePageButton(title, active, page, false, onPageChange);
        }
        // For navigation buttons
        if (['First', 'Previous', 'Next'].includes(title)) {
            // Disable Next if we're at the current page
            const isDisabled = disabled || (title === 'Next' && active);
            return this.renderSinglePageButton(title, active, page, isDisabled, onPageChange);
        }
        return null;
    }

    renderSinglePageButton(title, active, page, isDisabled, onPageChange) {
        return (
            <li key={`page-${title}`}>
                <button 
                    className={`btn ${active ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => onPageChange(page)}
                    disabled={isDisabled}
                    style={{ margin: '0 5px' }}
                >
                    {title}
                </button>
            </li>
        );
    }
    render() {
        const customTotal = (from, to, size) => (
            <span className="react-bootstrap-table-pagination-total">
                &nbsp;&nbsp;&nbsp;Showing { from } to { to } of { size } Results
            </span>
        );

        const expandRow = {
            onlyOneExpanding: true,
            renderer: row => (
                <div>
                    <Tabs
                        activeKey={this.state.logSelectedTabs[row.id] != null ? this.state.logSelectedTabs[row.id] : 1}
                        transition={false}
                        onSelect={(key) => this.handleLogTabSelect(row.id, key)}
                        id="log-details"
                    >
                        <Tab eventKey={1} title="Job Received">
                            <AceEditor
                                mode="javascript"
                                theme="tomorrow"
                                name={row.id + "_log_details"}
                                readOnly={true}
                                value={this.getPrettyJson(row.job_received)}
                                wrapEnabled={this.shouldWrapText(row.job_received)}
                                setOptions={{ 
                                    useWorker: true
                                }}
                                width="auto"
                                height="500px"
                                style={{ "marginTop": "10px" }}
                                editorProps={{
                                    $blockScrolling: true
                                }}
                            />
                        </Tab>
                        <Tab eventKey={2} title="Output">
                            <AceEditor
                                mode="javascript"
                                theme="tomorrow"
                                name={row.id + "_log_details"}
                                readOnly={true}
                                value={this.getPrettyJson(row.output)}
                                wrapEnabled={this.shouldWrapText(row.output)}
                                setOptions={{ 
                                    useWorker: true
                                }}
                                width="auto"
                                height="500px"
                                style={{ "marginTop": "10px" }}
                                editorProps={{
                                    $blockScrolling: true
                                }}
                            />
                        </Tab>
                        <Tab eventKey={6} title="Assets">
                            <Container>
                                <Row md={2}>
                                    <Col md={2}><strong>Log ID:</strong></Col>
                                    <Col md={10}>{row.id}</Col>
                                </Row>
                                <Row style={{ marginTop: '10px' }}>
                                    <Col className="d-flex justify-content-start" style={{ gap: '10px' }}>
                                        <ScreenshotViewer 
                                            row_id={row.id} 
                                            getLogDetails={this.getLogDetails} 
                                            currentExtraction={this.props.currentExtraction} 
                                            batchID={this.props.batchId}
                                        />
                                        <HTMLViewer 
                                            row_id={row.id} 
                                            getLogDetails={this.getLogDetails} 
                                            currentExtraction={this.props.currentExtraction} 
                                            batchID={this.props.batchId}
                                        />
                                        <ScriptViewer 
                                            row_id={row.id} 
                                            script={JSON.parse(this.getLogDetails(row.id).job_received).script} 
                                        />
                                    </Col>
                                    {/* <HARViewer row_id={row.id} getLogDetails={this.getLogDetails} currentExtraction={this.props.currentExtraction} /> */}
                                </Row>
                            </Container>
                        </Tab>
                    </Tabs>
                </div>
            )
        };
        return (    
            <div>
                <div className="row align-items-center">
                    <div className="col-auto">
                        {
                            <BatchSelector 
                                batches={this.props.batches}
                                currentExtraction={this.props.currentExtraction}
                                batchChanged={this.batchChanged}
                                stateManagementService={this.props.stateManagementService}
                            />
                        }
                    </div>
                    {this.props.currentExtraction.id != null && this.props.batchId != null && (
                        <>
                            <div className="col-auto">
                                <Button
                                variant="light"
                                onClick={() => this.refreshLogsHandler()}
                                >
                                    <FontAwesomeIcon icon={faRefresh} />
                                </Button>
                            </div>
                            <div className="col-auto">
                                {this.props.currentExtraction.id != null && this.props.batchId != null &&
                                    <Form.Check
                                    type="checkbox"
                                    variant="light"
                                    defaultChecked={this.state.hideRetry}
                                    onClick={e => this.toggleHideRetry(e.target.checked)} 
                                    label="Hide Non-Critical Retry Errors"
                                    />
                                }
                            </div>
                        </>
                        
                    )}
                     <div className="col text-end" style={{ paddingRight: "30px" }}>
                        {this.props.currentExtraction.id != null && this.props.batchId != null && (
                            <Button
                            variant="light"
                            onClick={() => this.retryCriticalJobsHandler()}
                            >
                                <FontAwesomeIcon icon={faPlay} /> Retry Critical Logs
                            </Button>
                        )}
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-auto">
                        &nbsp;
                    </div>
                </div>
                <div className="row">
                    {this.props.currentExtraction.id  != null && this.props.batchId != null && this.props.logs != null &&
                        <BootstrapTable 
                            remote 
                            keyField='id' 
                            data={this.props.logs} 
                            columns={logColumns} 
                            expandRow={expandRow} 
                            bordered={false} 
                            pagination={paginationFactory({
                                page: this.state.logPage,
                                sizePerPage: this.state.logSizePerPage,
                                totalSize: this.state.logTotalSize,
                                hidePageListOnlyOnePage: true,
                                withFirstAndLast: true,
                                paginationTotalRenderer:customTotal,
                                showTotal:true,
                                firstPageTitle: 'First',
                                prePageTitle: 'Previous',
                                nextPageTitle: 'Next',
                                lastPageTitle: '',
                                pageButtonRenderer: this.renderPageButton
                            })} 
                            onTableChange={this.handleTableChange} 
                        />
                    }
                </div>
                <div className="row">
                    {(this.props.currentExtraction.id  == null || this.props.batchId == null) &&
                        <div style={{ marginTop: '20px' }}>Please select a batch to view the logs</div>
                    }
                </div>
            </div>
        )
    }
}

export default LogViewer;